import React from 'react';

function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default function LandingCard({
  className,
  children,
  hover = true,
  as: Tag = 'div',
  ...rest
}) {
  return (
    <Tag
      className={cn(
        'rounded-2xl border border-white/10 bg-white/[0.04] shadow-[0_1px_0_rgba(255,255,255,0.04)]',
        hover && 'transition-transform duration-200 hover:-translate-y-0.5 hover:bg-white/[0.06] hover:shadow-[0_18px_60px_rgba(0,0,0,0.35)]',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

